<template>
  <div class="parent">
    <div class="box">
      <BInputText
        label-text="姓名："
        v-model="searchParam.userName"
        placeholder="姓名"
      />
      <BInputPullDown
        label-name="结业状态"
        v-model="searchParam.courseCompleteStatus"
        :Options="statusList"
         placeholder="全部"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div>
        </div>
        <div class="search-result-summary">
          <div class="summary">学员：{{ studentTotalNum }}人</div>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="pageList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:idPhotoUrl1="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <img
              v-if="item.data.idPhotoUrl !== '' && item.data.idPhotoUrl !== null"
              :src="item.data.idPhotoUrl"
              style="height: 60px; width: 60px; border-radius: 50%"
            />
            <img
              v-else
              src="@/assets/head_photo.png"
              style="height: 60px; width: 60px; border-radius: 50%"
            />
          </div>
        </template>
        <template v-slot:learnRates="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div style="width:40%;margin-right:10px;">
              <BProgressStudy v-model="item.data.learnRate" style="width: 100px;" />
            </div>
            <div style="width:20%;margin-top:3px;">{{item.data.learnRate}}%</div>
          </div>
        </template>
        
        <!-- <template v-slot:actions="item">
          <div class="btn-detail" @click="handleDetail(item.data)">详情</div>
        </template> -->
      </Table>
    </div>
  </div>
</template>
<script>
import {
  searchList,
  init,
} from "@/api/courseStudent";
import BInputText from "../../components2/BInputText";
import Table from "../../components2/Table";
import BBtnSecondary from "../../components2/BBtnSecondary";
import BProgressStudy from "../../components2/BProgressStudy";
import Hub from "../../events/Hub";
import BInputPullDown from "../../components2/BInputPullDown";
export default {
  name: "CourseManagement",
  components: {
    Table,
    BInputText,
    BBtnSecondary,
    BInputPullDown,
    BProgressStudy,
  },
  props: {
    classId: Number,
    classCourseId: Number,
  },
  data: () => ({
    id: 0,
    pageNum: 1,
    limit: 10,
    pageCount: 10,
    totalCount: 0,
    searchParam: {},
    studentTotalNum: 0,
    signInYesNum: 0,
    signInNoNum: 0,
    timeout: 3000,
    snackbarColor: "",
    snackbarText: "",
    totalPages: 0,
    page: 1,
    data: {},
    selected: [],
    singleSelect: false,
    loading: false,
    snackbar: false,
    snackbarObj: {
      snackbar: false,
      timeout: -1,
      color: "",
      text: "",
    },
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "center", width: '4%' },
      { text: "头像", value: "idPhotoUrl1", sortable: false, align: "center", width: '4%' },
      { text: "姓名", value: "userName", sortable: false, align: "center", width: '12%' },
      { text: "身份证号", value: "idCardNum", sortable: false, align: "center", width: '20%' },
      { text: "手机号码", value: "telNo", sortable: false, align: "center", width: '15%' },
      { text: "学习进度", value: "learnRates", sortable: false, align: "center", width: '17%' },
      { text: "结业状态", value: "courseComplete", sortable: false, align: "center", width: '10%' },
    ],
    pageList: [],
    deleteDialog: false,
    deleteDialogFlag: false,
    classNum: "",
    studentId: "",
    data_classId: "",
    list: [],
    controlFlag: "",
    statusList: [],
    signStatusList: [],
    navi: [
        {name: "course-management"},
        {name: "course_class"},
        {name: "course_student-management"},
    ],
  }),
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    this.init()
    this.doSearch(true);
    this.$nextTick(
      function () {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  methods: {
    async init () {
      const data = await init();
      this.statusList = data.data.statusList
      this.signStatusList = data.data.signStatusList
    },
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
      } else {
        // 查询条件赋值
        // if (this.$route.params.classId !== undefined) {
        //   this.classId = this.$store.params.classId;
        // }
      }
      this.searchList();
    },
    async searchList() {
      var param = {
        page: this.page,
        limit: this.limit,
        classId: this.classId,
        courseId: this.classCourseId,
        courseCompleteStatus: this.searchParam.courseCompleteStatus,
        userName: this.searchParam.userName,
        todaySignFlag: this.searchParam.todaySignFlag,
      };
      const data = await searchList(param);
      if (data.data.searchList != null || data.data.searchList === "") {
        this.pageList = data.data.searchList;
        this.studentTotalNum = data.data.studentTotalNum;
        this.signInYesNum = data.data.signInYesNum;
        this.signInNoNum = data.data.signInNoNum;
      }
      this.totalCount = data.data.totalCount;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
    },
    // handleDetail (item) {
    //     // 通知父组件打开弹层(并往上传图片页面传值classId)
    //     var obj = {
    //       classId: item.id,
    //       studentId:item.studentId,
    //       idCardNum:item.idCardNum,
    //       flag: "courseStudentDetail",
    //     }
    //     this.$emit('openFlag',obj)
    //   },
    // 添加编辑页面返回值
    set() {
        this.doSearch(true)
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
};
</script>

<style scoped>
.hover-btn {
  background-color: #4e74df;
  border-color: #4e74df;
  color: #ffffff !important;
}

.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}

  .box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
  }

  .parent {
    margin-top: 1em;
  }
</style>
